import { endOfMonth, startOfMonth, subMonths, UTCDate } from '@/utils/dates';

type GetReportingTimeframeArgs = {
  referenceDate?: Date;
};

export const getReportingTimeframe = ({ referenceDate = new UTCDate() }: GetReportingTimeframeArgs = {}) => {
  // We display 4 months of reporting data in the UI, starting reference month minus 3 and finishing in the reference month
  // i.e. if referenceDate is April 27th, 2025, we display data from January 2025 to end of month April 2025
  const endReportingDate = endOfMonth(referenceDate);
  const startReportingDate = startOfMonth(subMonths(endReportingDate, 3));

  return { endReportingDate, startReportingDate };
};
